/**
 *  @fileOverview Main app module
 *
 *  @author       Peter Schmiz <peter.schmiz@possible.com>
 *
 *  @requires     modules/navigation
 *  @requires     modules/custom-select-controller
 *  @requires     modules/wizard-logic
 *  @requires     utils/helper
 *  @requires     utils/cookie-handling
 */

import { helper } from './utils/helper';
import { cookieHandling } from './utils/cookie-handling';
import { search } from './modules/search';
import { share } from './modules/share';
import { navigation } from './modules/navigation';
import { calculator } from './modules/calculator';
import { accordion } from './modules/accordion';
import { customSelectController } from './modules/custom-select-controller';
import { wizardLogic } from './modules/wizard-logic';
import { tooltipController } from './modules/tooltip-controller';
import { tab } from './modules/tab';
import { imageLoader } from './modules/image-loader';
import { analytics } from './modules/analytics';
import { video } from './modules/video';
import { cookiePolicy } from './modules/cookiepolicy';

const OPT_COOKIE = 'pensionOptout';
const CP_COOKIE = 'cookiepolicy_banner';

const getCurrentPage = () => (document.body.getAttribute('data-page').toLowerCase());

class App {
  constructor() {
    helper.init();
    customSelectController.init();
    navigation.init();
    analytics.init();
    imageLoader.init();
    accordion.init();
    search.init();
    tooltipController.init();
    share.init();
    cookiePolicy.init();

    const calculatorBlock = document.querySelector('[data-calculator]');
    const cookiePolicyBanner = document.querySelector('[data-cookiepolicy]');

    if (calculatorBlock !== null) {
      calculator.init();
    }

    if (cookieHandling.checkCookie(OPT_COOKIE)) {
      const informationBlock = document.querySelector('section.information');
      if (informationBlock !== null) {
        informationBlock.classList.remove('information--hidden');
      }
    }

    if (cookieHandling.checkCookie(CP_COOKIE) && cookiePolicyBanner !== null) {
      document.body.removeChild(cookiePolicyBanner);
    } else if (cookiePolicyBanner !== null) {
      cookiePolicyBanner.classList.remove('cookiepolicy--hidden');
    }

    switch (getCurrentPage()) {
      case 'wizard':
        wizardLogic.init();
        break;
      case 'media':
        tab.init();
        video.init();
        break;
      default:
        break;
    }
  }
}

window.addEventListener('load', () => new App());



// WEBPACK FOOTER //
// ./src/js/app.js